import React from 'react'
import bio from '../../assets/images/bio.jpg'
import founderImg from '../../assets/images/founder.jpg'

class AboutFounder extends React.Component {
    render() {
        return (
            <>
                <section id='about-founder' className="founder bg-f6f6f6">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-5">
                                <img className="ptb-80 d-none d-lg-block" src={founderImg} alt="" />
                            </div>

                            <div className="col-lg-6 col-md-7">
                                <div className="about-strategy ptb-80">
                                    <div className="section-title">
                                        <h2><span>ABOUT</span> THE FOUNDER</h2>

                                        <p>Stanislav Shabaiev is a Ukrainian-born entrepreneur and investor with over 15 years of experience in IT, media, and digital innovation. His career spans software development, market strategy, and business consulting, with a focus on building scalable, data-driven ecosystems.</p>

                                        <p>As the founder of STNL Media Invest Holding Ltd, Stanislav oversees a diversified portfolio of 4 companies operating in online media, advertising technologies, SaaS, and information systems. The holding structure includes fully owned subsidiaries and strategic investments in external ventures across Europe and the US. He is also an investor with interests in several companies operating in the fields of healthcare, logistics, construction, and esports.</p>

                                        <p>His approach is rooted in long-term value creation, process optimization, and product innovation. Today, his investment and operational focus lies at the intersection of technology, sports media, and enterprise software solutions.</p>

                                        <p>With over 15 years of multidisciplinary experience, Stanislav brings strategic vision, operational discipline, and a commitment to building future-ready digital businesses.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
                <section id="bio-header" className="bio-area bg-white">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-5 d-flex">
                                <div className="about-strategy ptb-80">
                                    <div className="section-title">
                                        <h2>
                                            <span>STANISLAV <br /> SHABAIEV</span><br />
                                            BIO
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 absolute-image">
                                <img src={bio} alt="" />
                            </div>
                        </div>
                    </div>
                </section>
                <section id='bio' className="who-we-are ptb-80 bg-f6f6f6">
                    <div className="container">
                        <h3>Entrepreneur, Strategic Investor, and <br /> Advocate for Innovation</h3>
                        <br />
                        <p>
                            Cyprus-based and Ukraine-born, Stanislav Shabaiev is a seasoned entrepreneur and strategic investor with
                            more than 15 years of experience at the intersection of information technology, media, digital innovation,
                            and finance.</p>
                        <br />
                        <p>He has built a career on creating scalable, data-driven ecosystems that unite software development, market
                            strategy, and business consulting. Known for his strategic vision and disciplined execution, Stanislav has
                            successfully founded, managed, and invested in a diverse portfolio of companies across industries and global
                            markets.</p>
                        <br />
                        <p>Today, he oversees a group of four profitable companies spanning online media, advertising technologies,
                            SaaS, and enterprise information systems. These ventures operate under a shared vision—leveraging data and
                            technology to drive operational excellence and sustainable growth. Alongside these core businesses, he has
                            also made strategic investments in healthcare, logistics, construction, and electronic sports, reflecting both
                            versatility and a sharp instinct for emerging opportunities.</p>
                        <br />
                        <p>In parallel, Stanislav is active in multiple investment initiatives across Western Europe and holds equity
                            positions in several leading investment funds, further cementing his influence within the international
                            investment community.</p>
                        <br />
                        <p>He holds a Master’s degree in Software for Automated Systems from Donetsk National Technical University and
                            a Bachelor’s degree in Finance. This unique blend of technical and financial expertise allows him to bridge the
                            gap between technology and business, designing solutions that are both innovative and commercially viable.
                            Guided by a long-term perspective, Stanislav is driven by values that define both his professional and personal
                            ethos: a passion for innovation, a commitment to sustainable growth, a collaborative mindset, and a relentless
                            curiosity for emerging technologies.</p>
                        <br />
                        <p>Beyond business, he supports charitable initiatives and foundations, choosing to do so privately, in line with
                            his understated approach to philanthropy.</p>
                        <br />
                        <p> With a growing presence in Europe and a proven record of scaling successful ventures, Stanislav Shabaiev
                            continues to establish himself as a trusted leader and influential voice in technology and investment. His
                            current focus lies in backing and scaling IT and blockchain ventures across Western Europe—supporting
                            founders with capital, expertise, and access to networks, while offering institutional partners differentiated
                            deal flow in frontier technologies and entertainment platforms.</p>
                    </div>
                </section>
            </>
        )
    }
}

export default AboutFounder